import { getRequest, URL, putRequest, postRequest, deleteRequest } from "shared/utils";
import * as types from "./actionTypes";

const queryParms = (request) => {
  const {
    clientId,
    pageNumber,
    pageSize,
    sortColumn,
    sortDirection,
    searchKeyword,
    noticeDateStart,
    noticeDateEnd,
    filters,
  } = request;

  let parms = `?clientId=${clientId}&pageNumber=${pageNumber}&pageSize=${pageSize}`;

  if (sortColumn) {
    parms += `&sortColumn=${sortColumn}&sortDirection=${sortDirection}`;
  }

  if (searchKeyword) {
    parms += `&searchKeyword=${searchKeyword}`;
  }

  if (noticeDateStart && noticeDateEnd) {
    parms += `&noticeDateStart=${noticeDateStart}&noticeDateEnd=${noticeDateEnd}`;
  }

  if (filters) {
    Object.keys(filters).forEach((key, index) => {
      var filterBy = filters[key];

      if (filterBy && filterBy.length > 0) {
        filterBy.forEach((f) => {
          parms += `&${key}=${encodeURIComponent(f)}`;
        });
      }
    });
  }

  return parms;
};

export function getLeaseEvents(requestWithParams) {
  const url = `${URL.leaseEvent}/v2${queryParms(requestWithParams)}`;

  const request = getRequest(url);

  return {
    type: types.GET_LEASE_EVENTS,
    payload: request,
  };
}

export function getLeaseEventSpreadsheet(parms) {
  var utcOffset = new Date().getTimezoneOffset() / 60;

  utcOffset = utcOffset * -1;

  let url = `${URL.leaseEvent}/spreadsheet`;

  const { filters } = parms;

  delete parms.filters;

  for (var prop in filters) {
    if (Array.isArray(filters[prop]) && filters[prop].length === 0)
      delete filters[prop];
  }

  const request = postRequest(
    url,
    { ...parms, ...filters, utcOffset },
    false,
    "blob"
  );

  return {
    type: types.GET_LEASE_EVENT_SPREADSHEET,
    payload: request,
  };
}

export function getLeaseEventsByIds(ids) {
  let url = `${URL.leaseEvent}/ids?ids=${ids[0]}`; // ?ids=${id}`;

  if (ids.length > 1) {
    let idParms = "";

    ids.slice(1).forEach((id) => (idParms += `&ids=${id}`));

    url += idParms;
  }

  const request = getRequest(url);

  return {
    type: types.GET_LEASE_EVENTS_BY_IDS,
    payload: request,
  };
}

export function getLeaseEvent(id) {
  const url = `${URL.leaseEvent}/ids?ids=${id}`;

  const request = getRequest(url);

  return {
    type: types.GET_LEASE_EVENT,
    payload: request,
  };
}

export function getLeaseEventsSnoozed(requestWithParams) {
  const url = `${URL.leaseEvent}/snoozed/v2${queryParms(requestWithParams)}`;

  const request = getRequest(url);

  return {
    type: types.GET_LEASE_EVENTS_SNOOZED,
    payload: request,
  };
}

export function getLeaseEventsIgnored(requestWithParams) {
  const url = `${URL.leaseEvent}/ignored/v2${queryParms(requestWithParams)}`;

  const request = getRequest(url);

  return {
    type: types.GET_LEASE_EVENTS_IGNORED,
    payload: request,
  };
}

export function snoozeLeaseEvents(settings) {
    const { selectedLeaseEvents, snoozeIgnoreComment, snoozedUntil, by, clientId } =
    settings;

  const url = `${URL.leaseEvent}/snoozed?clientId=${clientId}`;

  let leaseEventsToSnooze = [];

  selectedLeaseEvents.forEach((le) => {
    const { leaseId, leaseEventId } = le;

    leaseEventsToSnooze.push({
      leaseId,
      leaseEventId,
      snoozedUntil,
      snoozedComment: snoozeIgnoreComment,
      createdBy: by,
    });
  });

  const request = postRequest(url, leaseEventsToSnooze);

  return {
    type: types.SNOOZE_LEASE_EVENTS,
    payload: request,
  };
}

export function ignoreLeaseEvents(settings) {
   const { selectedLeaseEvents, snoozeIgnoreComment, by , clientId } = settings;

  const url = `${URL.leaseEvent}/ignored?clientId=${clientId}`;

  let leaseEventsToIgnore = [];

  selectedLeaseEvents.forEach((le) => {
    const { leaseId, leaseEventId } = le;

    leaseEventsToIgnore.push({
      leaseId,
      leaseEventId,
      ignoreComment: snoozeIgnoreComment,
      createdBy: by,
    });
  });

  const request = postRequest(url, leaseEventsToIgnore);

  return {
    type: types.IGNORE_LEASE_EVENTS,
    payload: request,
  };
}

export function unSnoozeLeaseEvents(params) {
  const { selectedLeaseEvents, by, clientId } = params;

  let url = `${URL.leaseEvent}/snoozed?`;

  selectedLeaseEvents.forEach((le) => {
    url += `ids=${le.leaseEventSnoozeId}&`;
  });

  url += `deletedBy=${by}&clientId=${clientId}`;

  const request = deleteRequest(url);

  return {
    type: types.UNSNOOZE_LEASE_EVENTS,
    payload: request,
  };
}

export function unIgnoreLeaseEvents(params) {
  const { selectedLeaseEvents, by, clientId } = params;

  let url = `${URL.leaseEvent}/ignored?`;

  selectedLeaseEvents.forEach((le) => {
    url += `ids=${le.leaseEventIgnoredId}&`;
  });

  url += `deletedBy=${by}&clientId=${clientId}`;

  const request = deleteRequest(url);

  return {
    type: types.UNIGNORE_LEASE_EVENTS,
    payload: request,
  };
}

export function getAllLeaseEvents(requestWithParams) {
  const url = `${URL.leaseEvent}/v2${queryParms(requestWithParams)}`;

  const request = getRequest(url);

  return {
    type: types.GET_ALL_LEASE_EVENTS,
    payload: request,
  };
}

export function getAllLeaseEventsSnoozed(requestWithParams) {
  const url = `${URL.leaseEvent}/snoozed/v2${queryParms(requestWithParams)}`;

  const request = getRequest(url);

  return {
    type: types.GET_ALL_LEASE_EVENTS_SNOOZED,
    payload: request,
  };
}

export function getAllLeaseEventsIgnored(requestWithParams) {
  const url = `${URL.leaseEvent}/ignored/v2${queryParms(requestWithParams)}`;

  const request = getRequest(url);

  return {
    type: types.GET_ALL_LEASE_EVENTS_IGNORED,
    payload: request,
  };
}

export function getLeaseEventFilterOptions(clientId) {
  const url = `${URL.leaseEvent}/filterOptions?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_LEASE_EVENT_FILTER_OPTIONS,
    payload: request,
  };
}

export function getEventsLeaseNames(clientId) {
  const url = `${URL.leaseEvent}/leaseNames?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_EVENTS_LEASE_NAMES,
    payload: request,
  };
}

export function getLeaseEventStatuses(clientId) {
  const url = `${URL.leaseEvent}/statuses?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_LEASE_EVENT_STATUSES,
    payload: request,
  };
}

export const resetLeaseEventComments = () => ({
  type: types.RESET_LEASE_EVENT_COMMENTS,
});

export function getLeaseEventComments(leaseEventId) {
  const url = `${URL.leaseEvent}/${leaseEventId}/comments`;

  const request = getRequest(url);

  return {
    type: types.GET_LEASE_EVENT_COMMENTS,
    payload: request,
  };
}

export function createLeaseEventComment(data) {
  const url = `${URL.leaseEvent}/comment`;

  const request = postRequest(url, data);

  return {
    type: types.CREATE_LEASE_EVENT_COMMENT,
    payload: request,
  };
}

export function updateLeaseEventComment(data, clientId) {
  const url = `${URL.leaseEvent}/comment?clientId=${clientId}`;

  const request = putRequest(url, data);

  return {
    type: types.UPDATE_LEASE_EVENT_COMMENT,
    payload: request,
  };
}

export function deleteLeaseEventComment(data) {
  const { commentId, userEmail, clientId } = data;

  const url = `${URL.leaseEvent}/comment?id=${commentId}&deletedBy=${userEmail}&clientId=${clientId}`;

  return deleteRequest(url).then(() => ({
    type: types.DELETE_LEASE_EVENT_COMMENT,
    payload: { commentId: data.commentId },
  }));
}

export function getLeaseEventPageSize(userId, tableName) {
  const url = `${URL.leaseEvent}/pageSize?userId=${userId}&tableName=${tableName}`;

  const request = getRequest(url);

  return {
    type: types.GET_LEASE_EVENT_PAGE_SIZE,
    payload: request,
  };
}